
<div class="global-background-div">
   
    <!-- 1 - Main section -->
    <div class="panel-type-light panel-content-centered main-width" id="main-panel">
        <img 
            class="logo logo-size" src="assets/logos/Logo_ARTIS.svg" 
            alt="{{this.languageService.Strings.alts.logo_artis}}" oncontextmenu="return false;" draggable="false"/>
        <p class="title title-size">
            {{languageService.Strings.landingPageStrings.panel_1_title}}
        </p>
        <p class="subtitle subtitle-size">
            {{languageService.Strings.landingPageStrings.panel_1_subtitle}}
        </p>
    </div>


    <!-- 2 - Pain section -->
    <div class="panel-type-dark panel-content-centered flex-gap-30 vertical-padding main-width">
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column pain-column-small">
                <img class="clip-circle" src="assets/images/malnutrition_patient.jpg" 
                    alt="{{this.languageService.Strings.alts.problemImage_malnutritionPatient}}" oncontextmenu="return false;" draggable="false"/>
            </div>
            <div class="panel-content-single-column pain-column-large">
                <p class="noraml-text-light noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_2_string_1}} 
                    &nbsp;[
                    <a class="referece" (click)="referenceClicked('1')">1</a>, 
                    <a class="referece" (click)="referenceClicked('2')">2</a>
                    ]
                </p>
            </div>
        </div>
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column pain-column-large">
                <p class="noraml-text-light noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_2_string_2}}
                    &nbsp;[
                    <a class="referece" (click)="referenceClicked('3')">3</a>
                    ]
                </p>
            </div>
            <div class="panel-content-single-column pain-column-small">
                <img class="clip-circle" src="assets/images/malnutrition_cancer.jpg" 
                    alt="{{this.languageService.Strings.alts.problemImage_malnutritionCancer}}" oncontextmenu="return false;" draggable="false"/>
            </div>
        </div>
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column pain-column-small">
                <img class="clip-circle" src="assets/images/malnutrition_guides.jpg" 
                    alt="{{this.languageService.Strings.alts.problemImage_malnutritionGuides}}" oncontextmenu="return false;" draggable="false"/>
            </div>
            <div class="panel-content-single-column pain-column-large">
                <p class="noraml-text-light noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_2_string_3}}
                    &nbsp;[
                    <a class="referece" (click)="referenceClicked('1')">1</a>, 
                    <a class="referece" (click)="referenceClicked('4')">4</a>
                    ]
                </p>
            </div>
        </div>
    </div>


    <!-- 3 - Product section -->
    <div class="panel-type-light panel-content-centered vertical-padding main-width">
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column product-column-left">
                <img class="software-image" src="assets/images/PC_Software.png" 
                    alt="{{this.languageService.Strings.alts.focusedon_overview}}" oncontextmenu="return false;" draggable="false"/>
            </div>
            <div class="panel-content-single-column product-column-right flex-gap-10">
                <p class="text-title text-title-size">
                    {{languageService.Strings.landingPageStrings.panel_3_string_1}}
                </p> 
                <p class="noraml-text-dark text-justify noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_3_string_2}}
                </p> 
                <p class="noraml-text-dark text-justify noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_3_string_3}}
                </p> 
                <button 
                    mat-raised-button
                    color="primary"
                    class="base_buttons"
                    (click)="navigate('software')" 
                    style="margin-top:15px;"
                    button>
                        {{languageService.Strings.landingPageStrings.panel_3_button}}
                </button>
            </div>
        </div>
    </div>



    <!-- 4 - Value section -->
    <div class="panel-type-gray panel-content-centered flex-gap-50 vertical-padding main-width">
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column value-column-image">
                <img class="value-image value-image-size" src="assets/icons/Icon_Research_color.png" alt="" oncontextmenu="return false;" draggable="false"/>  
                <p class="noraml-text-dark text-center noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_4_string_1}} 
                </p>
            </div>
            
            <div class="panel-content-single-column value-column-image">
                <img class="value-image value-image-size" src="assets/icons/Icon_Valid_color.png" alt="" oncontextmenu="return false;" draggable="false"/>  
                <p class="noraml-text-dark text-center noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_4_string_2}} 
                </p>
            </div>

            <div class="panel-content-single-column value-column-image">
                <img class="value-image value-image-size" src="assets/icons/Icon_Patent_color.png" alt="" oncontextmenu="return false;" draggable="false"/>  
                <p class="noraml-text-dark text-center noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_4_string_3}} 
                </p>
            </div>

        </div>
    </div>



    <!-- 5 - Research and colaborations section -->
    <div class="panel-type-light panel-content-centered vertical-padding main-width">
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column columns-equal">
                <img class="colaboration-image colaboration-image-size" src="assets/images/research_colaboration.png" alt="" oncontextmenu="return false;" draggable="false"/>
            </div>
            <div class="panel-content-single-column columns-equal">
                <p class="text-title text-title-size colaboration-title-margin">
                    {{languageService.Strings.landingPageStrings.panel_5_string_1}}
                </p>
                <p class="noraml-text-dark text-justify noraml-text-size">
                    {{languageService.Strings.landingPageStrings.panel_5_string_2}}
                </p>
                <button 
                    mat-raised-button
                    color="primary"
                    class="base_buttons"
                    (click)="navigate('contact')" 
                    button
                    style="margin-top:15px;">
                        {{languageService.Strings.landingPageStrings.panel_5_button}}
                </button>
            </div>
        </div>    
    </div>



    <!-- 6 - FocusedON advantages section -->
    <div class="panel-type-darker panel-content-centered vertical-padding main-width">
        <p class="noraml-text-light text-center text-title-size">
            {{languageService.Strings.landingPageStrings.panel_6_string_title}}
        </p>
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column columns-equal advantages-pc-column-1">
                <div class="panel-content-two-columns-for-bullet-points"
                    *ngFor="let string_value of languageService.Strings.landingPageStrings.panel_6_string_list">
                    <p class="noraml-text-light text-left noraml-text-size bullet-point">
                        &#10003;
                    </p>
                    <p class="noraml-text-light text-left noraml-text-size text-next-to-bullet-point">
                        {{string_value}}
                    </p>
                </div>
            </div>
            <div class="panel-content-single-column columns-equal advantages-pc-column-2">
                <img class="advantages-image advantages-image-size" src="assets/images/report.png" 
                    alt="{{this.languageService.Strings.alts.focusedon_report}}" oncontextmenu="return false;" draggable="false"/>
            </div>
        </div>
    </div>




    <!-- 7 - Image Gallery -->
    <div class="panel-type-light panel-content-centered main-width" style="padding-bottom: 125px; padding-top: 100px;">
        <!-- Certifications -->
        <p class="text-title text-title-size colaboration-title-margin">
            {{languageService.Strings.landingPageStrings.panel_7_string_1}}
        </p>
        <div class="image-gallery" style="padding-bottom: 50px; padding-top: 20px;">
            <a *ngFor="let item of ItemList_certifications" (click)="itemClicked(item)" (keydown)="onItemKeyDown($event, item)" tabindex="0">
              <img [src]="item.src" [alt]="item.alt" oncontextmenu="return false;" draggable="false">
            </a>
        </div>
        <!-- Funding -->
        <!--
        <p class="text-title text-title-size colaboration-title-margin">
            {{languageService.Strings.landingPageStrings.panel_7_string_2}}
        </p>
        <div class="image-gallery" style="padding-bottom: 50px; padding-top: 20px;">
            <a *ngFor="let item of ItemList_funding" (click)="itemClicked(item)" (keydown)="onItemKeyDown($event, item)" tabindex="0">
              <img [src]="item.src" [alt]="item.alt" oncontextmenu="return false;" draggable="false">
            </a>
        </div>
        -->
        <!-- Partners -->
        <p class="text-title text-title-size colaboration-title-margin">
            {{languageService.Strings.landingPageStrings.panel_7_string_3}}
        </p>
        <div class="image-gallery" style="gap: 10px 80px;">
            <a *ngFor="let item of ItemList_partners" (click)="itemClicked(item)" (keydown)="onItemKeyDown($event, item)" tabindex="0">
              <img [src]="item.src" [alt]="item.alt" oncontextmenu="return false;" draggable="false">
            </a>
        </div>

        <!-- Funding -->
        <!-- TODO: Add text and button to transparency portal here here -->
    </div>



</div>